<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Prelims-new-page" lang="en-GB">Trigger warning:</p>
<p class="Prelims-main" lang="en-GB">The following content suggests and hints to some sensitive topics.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035801855_EPUB-4.vue?fd415800